import { AboutUsIcon } from './AboutUsIcon.tsx'
import { AirShipmentsIcon } from './AirShipmentsIcon.tsx'
import { AirplaneIcon } from './AirplaneIcon.tsx'
import { AirportDisruptionIcon } from './AirportDisruptionIcon.tsx'
import { AlertIcon } from './AlertIcon.tsx'
import { ArrivedAtPortOfUnladingIcon } from './ArrivedAtPortOfUnladingIcon.tsx'
import { ArrivedAvailableIcon } from './ArrivedAvailableIcon.tsx'
import { ArrowBackIcon } from './ArrowBackIcon.tsx'
import { ArrowDownIcon } from './ArrowDownIcon.tsx'
import { ArrowLeftIcon } from './ArrowLeftIcon.tsx'
import { ArrowUpIcon } from './ArrowUpIcon.tsx'
import { AutosizeIcon } from './AutosizeIcon.tsx'
import { BellIcon } from './BellIcon.tsx'
import { BusinessSaleIcon } from './BusinessSaleIcon.tsx'
import { CalendarIcon } from './CalendarIcon.tsx'
import { CarriersIcon } from './CarriersIcon.tsx'
import { CheckIcon } from './CheckIcon.tsx'
import { ChevronIcon } from './ChevronIcon.tsx'
import { ChevronRightIcon } from './ChevronRightIcon.tsx'
import { CicrleCheckIcon } from './CicrleCheckIcon.tsx'
import { CompleteIcon } from './CompleteIcon.tsx'
import { ContainersIcon } from './ContainersIcon.tsx'
import { ControlsIcon } from './ControlsIcon.tsx'
import { ConversationsIcon } from './ConversationsIcon.tsx'
import { CopyPasteIcon } from './CopyPasteIcon.tsx'
import { DcEmptyIcon } from './DcEmptyIcon.tsx'
import { DcFullIcon } from './DcFullIcon.tsx'
import { DcIcon } from './DcIcon.tsx'
import { DestinationPortIcon } from './DestinationPortIcon.tsx'
import { DetentionIcon } from './DetentionIcon.tsx'
import { DischargedAtPortOfUnladingIcon } from './DischargedAtPortOfUnladingIcon.tsx'
import { DoubleCheckIcon } from './DoubleCheckIcon.tsx'
import { DoubleChevronIcon } from './DoubleChevronIcon.tsx'
import { DoubleFramesIcon } from './DoubleFramesIcon.tsx'
import { DownloadIcon } from './DownloadIcon.tsx'
import { DraggableIcon } from './DraggableIcon.tsx'
import { EarthquakeIcon } from './EarthquakeIcon.tsx'
import { EllipsisMenuIcon } from './EllipsisMenuIcon.tsx'
import { EmptyPickedUpIcon } from './EmptyPickedUpIcon.tsx'
import { ExpandIcon } from './ExpandIcon.tsx'
import { ExportIcon } from './ExportIcon.tsx'
import { ExternalLinkIcon } from './ExternalLinkIcon.tsx'
import { ExtremeWeatherIcon } from './ExtremeWeatherIcon.tsx'
import { EyeIcon } from './EyeIcon.tsx'
import { EyeSlashedOutIcon } from './EyeSlashedOutIcon.tsx'
import { FactoryDisruptionIcon } from './FactoryDisruptionIcon.tsx'
import { FactoryFireIcon } from './FactoryFireIcon.tsx'
import { FdaActionIcon } from './FdaActionIcon.tsx'
import { FilterIcon } from './FilterIcon.tsx'
import { FloodIcon } from './FloodIcon.tsx'
import { FrameIcon } from './FrameIcon.tsx'
import { GearIcon } from './GearIcon.tsx'
import { GoldStarIcon } from './GoldStarIcon.tsx'
import { GraphQLIcon } from './GraphQLIcon.tsx'
import { HelpCircleIcon } from './HelpCircleIcon.tsx'
import { HomeIcon } from './HomeIcon.tsx'
import { InboundIcon } from './InboundIcon.tsx'
import { InfoOutlineIcon } from './InfoOutlineIcon.tsx'
import { ItemsIcon } from './ItemsIcon.tsx'
import { ItinerariesIcon } from './ItinerariesIcon.tsx'
import { ItineraryFallbackIcon } from './ItineraryFallbackIcon.tsx'
import { LegalActionIcon } from './LegalActionIcon.tsx'
import { LongArrowDownIcon } from './LongArrowDownIcon.tsx'
import { LongArrowUpIcon } from './LongArrowUpIcon.tsx'
import { MailIcon } from './MailIcon.tsx'
import { MilestoneBarcodeIcon } from './MilestoneBarcodeIcon.tsx'
import { MilestoneCalendarIcon } from './MilestoneCalendarIcon.tsx'
import { MilestoneLocationPinIcon } from './MilestoneLocationPinIcon.tsx'
import { MilestoneMegaphoneIcon } from './MilestoneMegaphoneIcon.tsx'
import { MinusIcon } from './MinusIcon.tsx'
import { MoveInlandIcon } from './MoveInlandIcon.tsx'
import { NetworkErrorIcon } from './NetworkErrorIcon.tsx'
import { NewsFallbackIcon } from './NewsFallbackIcon.tsx'
import { NewsIcon } from './NewsIcon.tsx'
import { OceanShipmentsIcon } from './OceanShipmentsIcon.tsx'
import { OnRailIcon } from './OnRailIcon.tsx'
import { OnWaterIcon } from './OnWaterIcon.tsx'
import { OrdersIcon } from './OrdersIcon.tsx'
import { OriginPortIcon } from './OriginPortIcon.tsx'
import { OutlineCloseIcon } from './OutlineCloseIcon.tsx'
import { PalletsIcon } from './PalletsIcon.tsx'
import { PencilIcon } from './PencilIcon.tsx'
import { PickedForDeliveryIcon } from './PickedForDeliveryIcon.tsx'
import { PinIcon } from './PinIcon.tsx'
import { PlusIcon } from './PlusIcon.tsx'
import { PortsIcon } from './PortsIcon.tsx'
import { ProfileIcon } from './ProfileIcon.tsx'
import { RecallIcon } from './RecallIcon.tsx'
import { RecommendedBobtailsIcon } from './RecommendedBobtailsIcon.tsx'
import { ReturnedIcon } from './ReturnedIcon.tsx'
import { SaveIcon } from './SaveIcon.tsx'
import { SearchIcon } from './SearchIcon.tsx'
import { ShareIcon } from './ShareIcon.tsx'
import { ShipmentsIcon } from './ShipmentsIcon.tsx'
import { SignOutIcon } from './SignOutIcon.tsx'
import { SingleChevronCircleIcon } from './SingleChevronCircleIcon.tsx'
import { StorybookIcon } from './StorybookIcon.tsx'
import { TransshipmentIcon } from './TransshipmentIcon.tsx'
import { TrashIcon } from './TrashIcon.tsx'
import { TriangleArrowIcon } from './TriangleArrowIcon.tsx'
import { TruckingShipmentsIcon } from './TruckingShipmentsIcon.tsx'
import { VendorIcon } from './VendorIcon.tsx'
import { WarningIcon } from './WarningIcon.tsx'
import { XIcon } from './XIcon.tsx'

export const iconRegistry = {
  AboutUsIcon,
  AirplaneIcon,
  TruckingShipmentsIcon,
  OceanShipmentsIcon,
  AirShipmentsIcon,
  AirportDisruptionIcon,
  MilestoneLocationPinIcon,
  MilestoneMegaphoneIcon,
  AlertIcon,
  ArrivedAtPortOfUnladingIcon,
  ArrivedAvailableIcon,
  MilestoneBarcodeIcon,
  ArrowBackIcon,
  ArrowDownIcon,
  MilestoneCalendarIcon,
  ArrowLeftIcon,
  ArrowUpIcon,
  AutosizeIcon,
  BellIcon,
  BusinessSaleIcon,
  CalendarIcon,
  CarriersIcon,
  CheckIcon,
  ChevronIcon,
  ChevronRightIcon,
  CicrleCheckIcon,
  CompleteIcon,
  ContainersIcon,
  ControlsIcon,
  ConversationsIcon,
  CopyPasteIcon,
  DcEmptyIcon,
  DcFullIcon,
  DcIcon,
  DestinationPortIcon,
  DetentionIcon,
  DischargedAtPortOfUnladingIcon,
  DoubleCheckIcon,
  DoubleChevronIcon,
  DownloadIcon,
  DraggableIcon,
  EarthquakeIcon,
  EmptyPickedUpIcon,
  ExpandIcon,
  ExportIcon,
  ExternalLinkIcon,
  ExtremeWeatherIcon,
  EyeIcon,
  EyeSlashedOutIcon,
  FactoryDisruptionIcon,
  FactoryFireIcon,
  FdaActionIcon,
  FilterIcon,
  FloodIcon,
  FrameIcon,
  GearIcon,
  GoldStarIcon,
  GraphQLIcon,
  HelpCircleIcon,
  HomeIcon,
  InboundIcon,
  InfoOutlineIcon,
  ItemsIcon,
  ItinerariesIcon,
  ItineraryFallbackIcon,
  LegalActionIcon,
  LongArrowDownIcon,
  LongArrowUpIcon,
  MailIcon,
  MinusIcon,
  EllipsisMenuIcon,
  MoveInlandIcon,
  NetworkErrorIcon,
  NewsFallbackIcon,
  NewsIcon,
  OnRailIcon,
  OnWaterIcon,
  OrdersIcon,
  OriginPortIcon,
  OutlineCloseIcon,
  PencilIcon,
  PalletsIcon,
  PickedForDeliveryIcon,
  PinIcon,
  PlusIcon,
  PortsIcon,
  ProfileIcon,
  RecallIcon,
  RecommendedBobtailsIcon,
  ReturnedIcon,
  SaveIcon,
  SearchIcon,
  ShareIcon,
  ShipmentsIcon,
  SignOutIcon,
  SingleChevronCircleIcon,
  StorybookIcon,
  TrashIcon,
  TransshipmentIcon,
  TriangleArrowIcon,
  DoubleFramesIcon,
  VendorIcon,
  WarningIcon,
  XIcon,
}

export type IconTypes = keyof typeof iconRegistry
